import palette from "./palette";
import typography from "./typography";
import breakpoints from "./breakpoints";
import overrides from "./overrides";
import internalConfig, { BaseTheme, ThemeConfig } from "./config";
import { createTheme, Theme } from "@mui/material";

const createCezTheme = (baseTheme: BaseTheme = "orange", inConfig?: ThemeConfig): Theme => {
    internalConfig.setBaseColor(baseTheme);
    if (inConfig) {
        internalConfig.updateConfig(inConfig);
    }

    const currentConfig = internalConfig.getConfig();

    return createTheme({
        palette: palette(currentConfig),
        typography: typography(currentConfig),
        breakpoints: breakpoints,
        spacing: currentConfig.spacing,
        components: overrides(currentConfig),
    });
};

export default createCezTheme;
